<template>
  <div class="viewDashBoard project-route-index">
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div key="1" v-if="loader" class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else class="white-row">
        <div class="show-project-portal-listing">
          <!-- Create Project Form  -->
          <div class="form-area">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-12">
                  <div class="row top-gen-heading">
                    <h1 class="global-style-heading">
                      Edit Lead
                    </h1>
                  </div>
                </div>
                <div class="col-sm-12">
                  <form
                    class="brand-form"
                    v-on:submit.prevent="onUpdate($event)"
                  >
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="title"
                              >Title: <span>*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Title"
                              v-model="formData.title"
                              :class="{
                                'input-border-errors':
                                  $v.formData.title.$dirty &&
                                  !$v.formData.title.required
                              }"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="email"
                              >Email: <span>*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Email"
                              v-model="formData.email"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="contact" class="control-label"
                              >Contact</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Contact"
                              v-model="formData.contact"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="zipcode" class="control-label"
                              >Zip Code</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Zip Code"
                              v-model="formData.zipcode"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="package" class="control-label"
                              >Package</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Package"
                              v-model="formData.package"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="amount" class="control-label"
                              >Amount</label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Amount"
                              v-model="formData.amount"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="lead_status_id" class="control-label"
                              >Lead Status</label
                            >
                            <Select2
                              :options="lead_status_options"
                              :settings="{
                                placeholder: 'Lead Status',
                                allowClear: true
                              }"
                              v-model="formData.lead_status_id"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="lead_step_id" class="control-label"
                              >Lead Steps</label
                            >
                            <Select2
                              :options="lead_step_options"
                              :settings="{
                                placeholder: 'Lead Steps',
                                allowClear: true
                              }"
                              v-model="formData.lead_step_id"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <h5>Tags</h5>
                      </div>
                       <div class="col-sm-12">
                        <div class="row">
                          <div class="form-group">
                            <label for="brand_id" class="control-label"
                              >Brand</label
                            >
                            <Select2
                              :options="brand_options"
                              @change="getAmOfBrand"
                              :settings="{
                                placeholder: 'Select Brand',
                                allowClear: true
                              }"
                              v-model="formData.brand_id"
                              :class="{
                                'input-border-errors':
                                  $v.formData.brand_id.$dirty &&
                                  !$v.formData.brand_id.required
                              }"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="lead_source_id" class="control-label"
                              >Lead Source</label
                            >
                            <Select2
                              :options="lead_source_options"
                              :settings="{
                                placeholder: 'Lead Source',
                                multiple: true
                              }"
                              v-model="formData.lead_source_id"
                              :class="{
                                'input-border-errors':
                                  $v.formData.lead_source_id.$dirty &&
                                  !$v.formData.lead_source_id.required
                              }"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="form-group">
                            <label for="am_id" class="control-label"
                              >Sales Person</label
                            >
                            <Select2
                              :options="ams_options"
                              :settings="{
                                placeholder: 'Sales Person',
                                multiple: true
                              }"
                              v-model="formData.am_id"
                              :class="{
                                'input-border-errors':
                                  $v.formData.am_id.$dirty &&
                                  !$v.formData.am_id.required
                              }"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="form-actions">
                            <button
                              :disabled="disableSubmitBtn"
                              type="submit"
                              id="save-form"
                              class="btn btn-primary default-global-btn"
                            >
                              Update
                            </button>
                            <div
                              v-if="disableSubmitBtn"
                              class="form_submit_loader"
                            >
                              <div class="lds-ellipsis">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { validationMixin } from "vuelidate";
const {
  required,
  minLength,
  email,
  numeric,
  url
} = require("vuelidate/lib/validators");

export default {
  mixins: [validationMixin],
  components: {
    Select2
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  validations: {
    formData: {
      title: {
        required
      },
      brand_id: {
        required
      },
      lead_source_id: {
        required
      },
      am_id: {
        required
      },
      amount: {
        required
      },

    }
  },
  data() {
    return {
      loader: true,
      brand_options: null,
      lead_source_options: null,
      lead_step_options : null,
      lead_status_options: null,
      ams_options : null,
      formData: {
        id: null,
        title: null,
        email: null,
        contact: null,
        zipcode: null,
        package : null,
        brand_id : null,
        lead_source_id : null,
        lead_status_id : null,
        lead_step_id : null,
        am_id : null,
        amount : 0,
      },
      disableSubmitBtn: false
    };
  },
  mounted() {
    document.title = this.$router.app._route.meta.pageTitle;
    this.editLead();
    this.getemployees();
    this.getBrands();
    this.getLeadSource();
    this.getLeadStatus();
    this.getLeadStep();
  },
  methods: {
    async editLead() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/leads/edit/"+this.$route.params.lead_id
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
            $this.formData.id = response.data.data.id;
            $this.formData.title = response.data.data.title;
            $this.formData.email = response.data.data.email;
            $this.formData.contact = response.data.data.contact;
            $this.formData.zipcode = response.data.data.zip_code;
            $this.formData.package  = response.data.data.package;
            $this.formData.brand_id  = response.data.data.brand_id;
            $this.formData.lead_source_id  = response.data.data.lead_source;
            $this.formData.lead_status_id  = response.data.data.status_id;
            $this.formData.lead_step_id  = response.data.data.step_id;
            $this.formData.am_id  = response.data.data.account_manager;
            $this.formData.amount = response.data.data.amount;
            $this.getProjectAms($this.formData.brand_id);
            $this.loader = false;
        }
      });
    },
    async getLeadStep(brandid) {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-lead-step"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.lead_step_options = response.data.data;
        }
      });
    },
    async getLeadStatus(brandid) {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-lead-status"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.lead_status_options = response.data.data;
        }
      });
    },
    getAmOfBrand() {
      this.$store.dispatch("generalLoader", {
        response: true
      });
      const $this = this;
      $this.formData.am_id = null;
      if ($this.formData.brand_id) {
        $this.getProjectAms($this.formData.brand_id);
      } else {
        $this.ams_options = null;
        $this.$store.dispatch("generalLoader", {
          response: false
        });
      }
    },
    async getProjectAms(brandid) {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-employees?brand_id=" + brandid
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.ams_options = response.data.data;
          $this.$store.dispatch("generalLoader", {
            response: false
          });
        }
      });
    },
    async getLeadSource() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "filters/get-lead-source"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.lead_source_options = response.data.data;
        }
      });
    },
    async getBrands() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "filters/get-project-brand"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.brand_options = response.data.data;
        }
      });
    },
    async getemployees() {
      const $this = this;
      await window.axios
        .get("/filters/get-employees")
        .then(resps => {
          $this.am_options = resps.data.data;
        })
        .catch(function(error) {
          $this.$store.dispatch("displayMessageErrors", {
            response: error.response,
            formEvent: null
          });
          $this.loader = false;
        });
    },
    async onUpdate(event) {
      const $this = this;
      $this.disableSubmitBtn = true;
      $this.$v.$touch();

      if ($this.$v.$invalid) {
        $this.$store.dispatch("showtostrMessageNotifications", {
          message: "Please fill all the fields to proceed form!",
          type: "error"
        });
        $this.disableSubmitBtn = false;
        return;
      }

      const data = $this.$store.dispatch("postHttp", {
        url: "leads/lead-update",
        formDetails: this.formData,
        formEvent: event.target
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.$store.dispatch("displayMessageErrors", {
            response: response,
            formEvent: event.target
          });
          $this.disableSubmitBtn = false;
          if (Object.keys($this.$route.query).length) {
              console.log($this.$route.query);
              // $this.$router.push("/leads?current_page="+$this.$route.query.current_page+'&highlited='+$this.$route.params.lead_id);
              $this.$router.push("/leads?current_page=" + $this.$route.query.current_page +
                '&search='+$this.$route.query.search +
                '&emp_id='+$this.$route.query.emp_id +
                '&brand_id='+$this.$route.query.brand_id +
                '&lead_status_id='+$this.$route.query.lead_status_id +
                '&lead_step_id='+$this.$route.query.lead_step_id +
                '&lead_source_id='+$this.$route.query.lead_source_id +
                '&lead_source_id_remove_tag='+$this.$route.query.lead_source_id_remove_tag +
                '&from_date='+$this.$route.query.from_date +
                '&number_per_page='+$this.$route.query.number_per_page +
                '&to_date='+$this.$route.query.to_date +
                '&highlited='+$this.$route.params.lead_id
              );
          }
        }
      });
      $this.disableSubmitBtn = false;
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  }
};
</script>
<style lang="scss" scoped>
body .form-area .form-group label span {
  color: red;
}
body .white-row.loader-route {
  top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.project-route-index {
  .show-project-portal-listing {
    .general-filters {
      .form-group {
        width: 100%;
      }
      .form-actions {
        width: 100%;
        button {
          width: 100%;
          margin-left: 0;
          padding: 5px 0;
        }
      }
      span.select2.select2-container.select2-container--default {
        width: 100% !important;
      }
    }
    h4 {
      letter-spacing: 0.28px;
      color: #323f54;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 0;
      padding-bottom: 7px;
    }
    p {
      margin: 0;
      letter-spacing: 0.28px;
      color: #2a1c0b;
    }
    section {
      border-bottom: 1px solid #ebebeb;
      padding: 30px 0;
      &.client-projects {
        padding-bottom: 0px;
        h4 {
          padding: 5px 0 25px;
        }
        .wrap-box {
          background: #faf9f7 0% 0% no-repeat padding-box;
          border-radius: 3px;
          padding: 20px 15px;
          min-height: 231px;
          margin-bottom: 30px;
          .box {
            position: relative;
            .project-details {
              p {
                &.project-id {
                  background: #ece9df 0% 0% no-repeat padding-box;
                  border-radius: 3px;
                  display: inline-block;
                  letter-spacing: 0.24px;
                  color: #323f54;
                  font-size: 12px;
                  padding: 4px 10px;
                }
                &.project-status {
                  letter-spacing: 0.24px;
                  color: #323f54;
                  font-size: 12px;
                  padding: 3px 0 15px;
                  font-weight: 400;
                }
              }
              .project-listing {
                padding: 15px 0 15px;
                p {
                  margin: 0;
                  letter-spacing: 0.28px;
                  color: #323f54;
                  font-size: 14px;
                  font-weight: bold;
                  text-transform: inherit;
                  line-height: 25px;
                }
              }
            }
            .footer-box {
              display: block;
              position: relative;
              width: 100%;
              padding: 20px 0 10px;
              border-top: 1px solid rgba(0, 0, 0, 0.1);
              .usr-role {
                p {
                  letter-spacing: 0.24px;
                  color: #918a82;
                  font-weight: 300;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>